
<template>
  <div>
    <div>
      <header v-if="invoice">
        <div
          class="flex-on-small-screen"
          style="margin: 20px; color: #474747; justify-content: space-between; color: white;"
        >
          <!-- header left -->
          <div>
            <img
              style="height: 60px; margin-left: -8px; margin-bottom: 20px;"
              src="/img/logo/grafias_large_ondark.png"
              alt="Grafias"
            >
            <div style="font-weight: 700;">
              LO Media
            </div>
            <div>
              Postboks 8964 Youngstorget
            </div>
            <div>
              0028 Oslo
            </div>
          </div>
          <!-- header right -->
          <div>
            <div
              class="invoice-title"
              style="margin-bottom: 20px;"
            >
              Invoice
            </div>
            <div style="font-weight: 400; font-size: 13px;">
              <div>
                Invoice Number : {{ invoiceNumber }}
              </div>
              <div>
                Date Issued : {{ getDateInvoice }}
              </div>
              <div>
                Payment Method : {{ invoice && invoice.payment_method }}
              </div>
            </div>
          </div>
        </div>
      </header>
      <body>
        <div style="margin: 20px; color: white;">
          <!-- customer name -->
          <div style="font-weight: 600; font-size: 18px;">
            Paid By:
          </div>
          <div style="font-weight: 600; font-size: 30px;">
            {{ invoice && invoice.bill_to_name }}
          </div>
          <div> {{ invoice && invoice.bill_to_email }} </div>
          <!-- price -->
          <div style="margin-top: 20px; font-weight: 600; font-size: 30px;">
            {{ invoice && invoice.amount ? convertToUsd(invoice.amount) : null }}
          </div>
          <table style="border-collapse: collapse; width: 100%;">
            <thead>
              <tr>
                <th style="border-bottom: 1px solid lightgray; text-align: left; padding: 8px;">
                  Description
                </th>
                <th style="border-bottom: 1px solid lightgray; text-align: left; padding: 8px;">
                  Qty
                </th>
                <th style="border-bottom: 1px solid lightgray; text-align: left; padding: 8px;">
                  Unit Price
                </th>
                <th style="border-bottom: 1px solid lightgray; text-align: left; padding: 8px;">
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="border-bottom: 1px solid lightgray; text-align: left; padding: 8px;">
                  {{ invoice && invoice.description }}
                </td>
                <td style="border-bottom: 1px solid lightgray; text-align: left; padding: 8px;">
                  1
                </td>
                <td style="border-bottom: 1px solid lightgray; text-align: left; padding: 8px;">
                  {{ invoice && invoice.amount ? convertToUsd(invoice.amount) : null }}
                </td>
                <td style="border-bottom: 1px solid lightgray; text-align: left; padding: 8px; text-align: right;">
                  {{ invoice && invoice.amount ? convertToUsd(invoice.amount) : null }}
                </td>
              </tr>
              <tr v-if="invoice && invoice.discount && parseInt(invoice.discount) > 0">
                <td />
                <td />
                <td
                  style="text-align: left; padding: 8px; text-align: right;"
                >
                  Discount {{ invoice && invoice.discount }}%
                </td>
                <td style="border-bottom: 1px solid lightgray; text-align: left; padding: 8px; text-align: right; text-align: right;">
                  {{ convertToUsd((invoice.amount * (parseInt(invoice.discount) / 100))) }}
                </td>
              </tr>
              <tr>
                <td />
                <td />
                <td
                  style="text-align: left; padding: 8px; text-align: right;"
                >
                  Amount
                </td>
                <td style="border-bottom: 1px solid lightgray; text-align: left; padding: 8px; text-align: right;">
                  {{ invoice && invoice.amount && invoice.discount ?
                    convertToUsd(invoice.amount - (invoice.amount * (parseInt(invoice.discount) / 100))) :
                    convertToUsd(invoice.amount) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </body>
      <footer>
        <div
          style="margin: 20px;font-size: 10px; color: lightgray"
        >
          Grafias - Runs lower third graphics | app.grafiaslive.com
        </div>
      </footer>
    </div>


    <div class="absolute hidden">
      <div ref="invoiceToPrint">
        <header v-if="invoice">
          <div
            class="flex-on-small-screen"
            style="margin: 20px; color: #474747; justify-content: space-between;"
          >
            <!-- header left -->
            <div>
              <img
                style="height: 60px; margin-left: -8px; margin-bottom: 20px;"
                src="/img/logo/grafias_large_onwhite.png"
                alt="Grafias"
              >
              <div style="font-weight: 700;">
                LO Media
              </div>
              <div>
                Postboks 8964 Youngstorget
              </div>
              <div>
                0028 Oslo
              </div>
            </div>
            <!-- header right -->
            <div>
              <div
                class="invoice-title"
                style="margin-bottom: 20px;"
              >
                Invoice
              </div>
              <div style="font-weight: 400; font-size: 13px;">
                <div>
                  Invoice Number : {{ invoiceNumber }}
                </div>
                <div>
                  Date Issued : {{ getDateInvoice }}
                </div>
                <div>
                  Payment Method : {{ invoice && invoice.payment_method }}
                </div>
              </div>
            </div>
          </div>
        </header>
        <body style="color: #474747; background-color: white;">
          <div style="margin: 20px;">
            <!-- customer name -->
            <div style="font-weight: 600; font-size: 18px;">
              Paid By:
            </div>
            <div style="font-weight: 600; font-size: 30px;">
              {{ invoice && invoice.bill_to_name }}
            </div>
            <div> {{ invoice && invoice.bill_to_email }} </div>
            <!-- price -->
            <div style="margin-top: 20px; font-weight: 600; font-size: 30px;">
              {{ invoice && invoice.amount ? convertToUsd(invoice.amount) : null }}
            </div>
            <table style="border-collapse: collapse; width: 100%; ">
              <thead>
                <tr>
                  <th style="border-bottom: 1px solid lightgray; text-align: left; padding: 8px;">
                    Description
                  </th>
                  <th style="border-bottom: 1px solid lightgray; text-align: left; padding: 8px;">
                    Qty
                  </th>
                  <th style="border-bottom: 1px solid lightgray; text-align: left; padding: 8px;">
                    Unit Price
                  </th>
                  <th style="border-bottom: 1px solid lightgray; text-align: left; padding: 8px;">
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="border-bottom: 1px solid lightgray; text-align: left; padding: 8px;">
                    {{ invoice && invoice.description }}
                  </td>
                  <td style="border-bottom: 1px solid lightgray; text-align: left; padding: 8px;">
                    1
                  </td>
                  <td style="border-bottom: 1px solid lightgray; text-align: left; padding: 8px;">
                    {{ invoice && invoice.amount ? convertToUsd(invoice.amount) : null }}
                  </td>
                  <td style="border-bottom: 1px solid lightgray; text-align: left; padding: 8px; text-align: right;">
                    {{ invoice && invoice.amount ? convertToUsd(invoice.amount) : null }}
                  </td>
                </tr>
                <tr v-if="invoice && invoice.discount && parseInt(invoice.discount) > 0">
                  <td />
                  <td />
                  <td
                    style="text-align: left; padding: 8px; text-align: right;"
                  >
                    Discount {{ invoice && invoice.discount }}%
                  </td>
                  <td style="border-bottom: 1px solid lightgray; text-align: left; padding: 8px; text-align: right; text-align: right;">
                    {{ convertToUsd((invoice.amount * (parseInt(invoice.discount) / 100))) }}
                  </td>
                </tr>
                <tr>
                  <td />
                  <td />
                  <td
                    style="text-align: left; padding: 8px; text-align: right;"
                  >
                    Amount
                  </td>
                  <td style="border-bottom: 1px solid lightgray; text-align: left; padding: 8px; text-align: right;">
                    {{ invoice && invoice.amount && invoice.discount ?
                      convertToUsd(invoice.amount - (invoice.amount * (parseInt(invoice.discount) / 100))) :
                      convertToUsd(invoice.amount) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </body>
        <footer>
          <div
            style="margin: 20px;font-size: 10px; color: lightgray"
          >
            Grafias - Runs lower third graphics | app.grafiaslive.com
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import html2pdf from 'html2pdf.js';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat.js';

dayjs.extend(advancedFormat);
/* eslint-disable vue/html-closing-bracket-spacing */
export default {
	components: {
	},
	props: {
		invoice: {
			type: Object,
			default: () => {},
		},
		invoiceNumber: {
			type: String,
			default: () => '',
		},
	},
	data() {
		return {
		};
	},
	computed: {
		getDateInvoice() {
			return dayjs(this.invoice.date, 'YYYY-MM-DD').format('MMMM Do YYYY');
		},
	},
	watch: {},
	created() {},
	mounted() {},
	beforeUnmount() {},
	methods: {
		convertToUsd(amount) {
			const formatter = new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: 'USD',
				minimumFractionDigits: amount % 1 === 0 ? 0 : 2, // Set minimumFractionDigits to 0 if the amount is a whole number, otherwise set to 2
				maximumFractionDigits: 2, // Maximum fraction digits
			});
			return formatter.format(amount);
		},
		downloadPDF() {
			html2pdf(this.$refs.invoiceToPrint, {
				margin: 0.5,
				filename: 'invoice-grafias.pdf',
				image: { type: 'jpeg', quality: 0.98 },
				html2canvas: { dpi: 192, letterRendering: true },
				jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' },
			});
		},
	},
};
</script>
<style>
@media (min-width: 768px) {
  .flex-on-small-screen {
    display: flex;
  }
  .invoice-title{
    font-size: 40px;
    font-weight: 500;
  }
}
@media (max-width: 767px) {
  .invoice-title{
    font-size: 16x;
    margin-top: 20px;
    font-weight: 700;
  }
}
</style>
